import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../config/axios';
import { Modal } from 'react-bootstrap';
import { Projects } from '../FilterDropdown';
import Select from "react-select";
import { CSSForSelect, CSSForSelect10vWWidth, CSSForSelect15vWWidth, handleErrorToast, ProgressModal } from '../CustomFunctions';
import { formatDateDD_MM_YYYY, formatDateDDMMYYYY } from '../Date';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteDustbin } from '../AllSvg';

const BulkLetterDelete = ({ projectList, subcompany, LetterTypeOptions, getData }) => {
    const [show, setShow] = useState(false);
    const [toggleProject, setToggleProject] = useState("null");
    const [letterType, setLetterType] = useState("null");
    const [matterRelatedTo, setMatterRelatedTo] = useState("null");
    const [letterData, setLetterData] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [errors, setErrors] = useState({});
    const [deleteModel, setDeleteModel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ids, setIds] = useState([]);

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setToggleProject(`null`);
        setLetterType(`null`);
        setMatterRelatedTo(`null`);
        setIds([]);
        setSelectedRows(new Set())
        setLetterData([])
        setErrors({})

    }
    const handleCloseModel = () => setDeleteModel(false);

    const getLetterData = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/letterrecordbyfilters/${toggleProject}/${matterRelatedTo}/${letterType}/`
            );
            setLetterData(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (show && toggleProject !== "null" && letterType !== "null" && matterRelatedTo !== "null") {
            getLetterData();
        }
    }, [show, toggleProject, letterType, matterRelatedTo]);

    useEffect(() => {
        setIds(Array.from(selectedRows));
    }, [selectedRows]);

    const matterRelated = [
        { id: "contractor", label: "Contractor" },
        { id: "consultant", label: "Consultant" },
    ];

    const matterRelatedTpOptions = matterRelated.map(i => ({ value: i.id, label: i.label }));

    const handlematterRelatedTpOptions = (selectedOption) => setMatterRelatedTo(selectedOption?.value || "null");
    const handleLetterTypeOption = (selectedOption) => setLetterType(selectedOption?.value || "null");

    const handleCheckboxChange = (letterId) => {
        setSelectedRows(prev => {
            const updated = new Set(prev);
            if (updated.has(letterId)) updated.delete(letterId);
            else updated.add(letterId);
            return updated;
        });
    };

    const handleSelectAll = () => setSelectedRows(new Set(letterData.map(l => l.id)));
    const handleUndoAll = () => setSelectedRows(new Set());

    const handleShowModel = () => {
        const newErrors = {};
        if (toggleProject === "null") newErrors.project = "Project is required";
        if (letterType === "null") newErrors.lettertype = "Letter Type is required";
        if (matterRelatedTo === "null") newErrors.matterRelatedTo = "Matter Related To is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return; // Stop if fields not filled
        if (ids.length === 0) {
            toast.error("Please select at least one letter to proceed");
            return;
        }

        setDeleteModel(true);
    };

    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);


    const handleSubmit = async () => {
        if (ids.length === 0) return toast.error("Please select at least one letter to delete");
        setLoading(true);
        setShowProgressModal(true);
        const loadingToastId = toast.loading("Deleting letters...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            setUploadProgress(progress);
            if (progress >= 100) clearInterval(interval);
        }, 100);
        try {
            const res = await axios.delete(`${BASE_URL}/siteproject/bulkletterdelete/`, { data: { ids } });
            if (res.status === 200) {
                await getData();
                handleClose();
                setDeleteModel(false);
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Data Deleted successfully.");
                }, 500);
            } else {
                toast.error("Something went wrong");
            }
        } catch (err) {
            clearInterval(interval); // Stop simulated progress
            setUploadProgress(0); //
            toast.dismiss(loadingToastId);
            toast.error(err.message || "Error deleting letters");
        } finally {
            setTimeout(() => {
                setShowProgressModal(false); // Hide modal even after error
            }, 1000);
            setLoading(false);
        }
    };

    return (
        <>
            <button
                className="clearbutton"
                onClick={handleShow}
                style={{
                    padding: "10px"
                }}
            >
                <span className="transition"></span>
                <span className="gradient"></span>
                <span className="label"><DeleteDustbin /> Delete Multiple Letters</span>
            </button>


            {
                showProgressModal ?
                    <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
                    <Modal show={show} onHide={handleClose} dialogClassName='model-width60vw'>
                        <Modal.Header closeButton>
                            <Modal.Title>{deleteModel ? "Confirm Deletion" : "Delete Multiple Letters"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {!deleteModel ? (
                                <>

                                    <div className='flex-row justify-between'>
                                        <Projects
                                            inputvalue="project"
                                            usedFor="form"
                                            toggleProject={toggleProject}
                                            setToggleProject={setToggleProject}
                                            value="id"
                                            subcompany={subcompany}
                                            error={errors.project}
                                            SetErrors={setErrors}
                                            title="small"
                                        />
                                        <div className="form-group">
                                            <label>Select Letter Type <span className="required">*</span></label>
                                            <Select
                                                options={LetterTypeOptions}
                                                onChange={handleLetterTypeOption}
                                                value={letterType === "null" ? null : LetterTypeOptions.find(opt => opt.value === letterType)}
                                                placeholder="Select Letter Type"
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect15vWWidth}
                                            />
                                            {errors.lettertype && <div className="error-message">{errors.lettertype}</div>}
                                        </div>

                                        {/* Matter Related */}
                                        <div className="form-group">
                                            <label>Select Matter Related To <span className="required">*</span></label>
                                            <Select
                                                options={matterRelatedTpOptions}
                                                onChange={handlematterRelatedTpOptions}
                                                value={matterRelatedTo === "null" ? null : matterRelatedTpOptions.find(opt => opt.value === matterRelatedTo)}
                                                placeholder="Select..."
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect10vWWidth}
                                            />
                                            {errors.matterRelatedTo && <div className="error-message">{errors.matterRelatedTo}</div>}
                                        </div>
                                    </div>


                                    {/* Show table only if data exists */}
                                    {letterData.length > 0 && (
                                        <>
                                            <div className='flex-row' style={{ justifyContent: `flex-end`, marginBottom: "10px" }}>
                                                <div className='flex-row justify-between' style={{ width: `27%` }}>
                                                    <button className="viewbutton" onClick={handleSelectAll}>Select All Letters</button>
                                                    <button className="viewbutton" onClick={handleUndoAll}>Undo Letters</button>
                                                </div>

                                            </div>
                                            <div className='table-css-white-background scroll-container'>
                                                <div className="table-container scrollbar" style={{ width: "100%" }}>
                                                    <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                                        <thead className="table-heading" style={{ zIndex: 1 }}>
                                                            <tr className="modal-padding-heading custom-table-head-tr">
                                                                <th className="table-heading-text">S.No</th>
                                                                <th className="table-heading-text">Letter Number</th>
                                                                <th className="table-heading-text">Letter Type</th>
                                                                <th className="table-heading-text " style={{ width: `5vw` }}>Date</th>
                                                                <th className="table-heading-text">Subject</th>
                                                                <th className="table-heading-text">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {letterData
                                                                .sort((a, b) => new Date(b.letter_date) - new Date(a.letter_date))
                                                                .map((letter, index) => (
                                                                    <tr key={index} className={selectedRows.has(letter.id) ? "cut-row modal-padding-heading " : "modal-padding-heading custom-table-head-tr"}>
                                                                        <td style={{ padding: `30px` }} >{index + 1}.</td>
                                                                        <td style={{ padding: `30px` }} >{letter.letter_num}</td>
                                                                        <td style={{ padding: `30px` }} >{letter.lettertype}</td>
                                                                        <td style={{ padding: `30px` }} >{formatDateDD_MM_YYYY(letter.letter_date)}</td>
                                                                        <td style={{ padding: `30px` }} >{letter.subject}</td>
                                                                        <td style={{ padding: `30px` }} >
                                                                            <div className="checkbox-wrapper-12">
                                                                                <div className="cbx">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectedRows.has(letter.id)}
                                                                                        onChange={() => handleCheckboxChange(letter.id)}
                                                                                        id={`cbx-${letter.id}`} // Added dynamic id for label
                                                                                    />
                                                                                    <label htmlFor={`cbx-${letter.id}`}></label>
                                                                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                                        <path d="M2 8.36364L6.23077 12L13 2"></path>
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>


                                        </>
                                    )}

                                    <div className="button-models">
                                        <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                                        <button class="nextbutton" onClick={handleShowModel}>
                                            <span>Preview</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 43">
                                                <polygon
                                                    points="39.58,4.46 44.11,0 66,21.5 44.11,43 39.58,38.54 56.94,21.5"
                                                ></polygon>
                                                <polygon
                                                    points="19.79,4.46 24.32,0 46.21,21.5 24.32,43 19.79,38.54 37.15,21.5"
                                                ></polygon>
                                                <polygon
                                                    points="0,4.46 4.53,0 26.42,21.5 4.53,43 0,38.54 17.36,21.5"
                                                ></polygon>
                                            </svg>
                                        </button>

                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='table-css-white-background scroll-container'>
                                        <div className="table-container scrollbar" style={{ width: "100%" }}>
                                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                                <thead className="table-heading" style={{ zIndex: 1 }}>
                                                    <tr className="modal-padding-heading custom-table-head-tr">
                                                        <th className="table-heading-text">S.No</th>
                                                        <th className="table-heading-text">Letter Number</th>
                                                        <th className="table-heading-text">Letter Type</th>
                                                        <th className="table-heading-text">Date</th>
                                                        <th className="table-heading-text">Subject</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {letterData.filter(l => selectedRows.has(l.id))
                                                        .sort((a, b) => new Date(b.letter_date) - new Date(a.letter_date))
                                                        .map((letter, index) => (
                                                            <tr key={index} className={"modal-padding-heading custom-table-head-tr"}>
                                                                <td style={{ padding: `30px` }} >{index + 1}.</td>
                                                                <td style={{ padding: `30px` }} >{letter.letter_num}</td>
                                                                <td style={{ padding: `30px` }} >{letter.lettertype}</td>
                                                                <td style={{ padding: `30px` }} >{formatDateDDMMYYYY(letter.letter_date)}</td>
                                                                <td style={{ padding: `30px` }} >{letter.subject}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                    <div className="button-models">
                                        <button className="cancelbutton" onClick={handleCloseModel}>Go Back</button>

                                        <button className="deletesubmitbutton" onClick={handleSubmit} type="submit">
                                            <span className="deletesubmitbutton__text">Delete</span>
                                            <span className="deletesubmitbutton__icon">
                                                <svg
                                                    className="svg"
                                                    height="512"
                                                    viewBox="0 0 512 512"
                                                    width="512"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <title>Delete</title>
                                                    <path
                                                        d="M112,112l20,320c.95,18.49,14.4,32,32,32H348c17.67,0,30.87-13.51,32-32l20-320"
                                                        style={{
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></path>
                                                    <line
                                                        x1="80"
                                                        y1="112"
                                                        x2="432"
                                                        y2="112"
                                                        style={{
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeMiterlimit: 10,
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></line>
                                                    <path
                                                        d="M192,112V72h0a23.93,23.93,0,0,1,24-24h80a23.93,23.93,0,0,1,24,24h0v40"
                                                        style={{
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></path>
                                                    <line
                                                        x1="256"
                                                        y1="176"
                                                        x2="256"
                                                        y2="400"
                                                        style={{
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></line>
                                                    <line
                                                        x1="184"
                                                        y1="176"
                                                        x2="192"
                                                        y2="400"
                                                        style={{
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></line>
                                                    <line
                                                        x1="328"
                                                        y1="176"
                                                        x2="320"
                                                        y2="400"
                                                        style={{
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "32px",
                                                        }}
                                                    ></line>
                                                </svg>
                                            </span>
                                        </button>


                                    </div>
                                </>
                            )}
                            <ToastContainer
                                position="top-center"
                                autoClose={1000}
                                hideProgressBar={false}
                                newestOnTop={true}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                        </Modal.Body>
                    </Modal >
            }
        </>
    );
};


export { BulkLetterDelete };
